"use strict";
import { __module as r } from "./index.es462.js";
import { __require as n } from "./index.es463.js";
var a;
function d() {
  return a ? r.exports : (a = 1, (function(u, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const o = (t, l) => process.env.__NEXT_I18N_SUPPORT ? n().normalizeLocalePath(t, l) : {
      pathname: t,
      detectedLocale: void 0
    };
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), u.exports = e.default);
  })(r, r.exports), r.exports);
}
export {
  d as __require
};
//# sourceMappingURL=index.es395.js.map
